import { type MetaFunction } from '@remix-run/node'
import { Link, Outlet } from '@remix-run/react'
import { Col, Container, Row } from 'reactstrap'

import { metaTitleAndDescription } from '#app/helpers/metaTags.helper.ts'

import logo from '../../../public/images/logo.svg'

export const meta: MetaFunction = () => {
  return metaTitleAndDescription({
    title: 'Clube do Tennis',
    description: 'Clube do Tennis - O local onde os tenistas se encontram',
    content_type: 'website',
  })
}

export default function ClubLayout() {
  return (
    <div>
      <div id="layout-wrapper">
        <header id="page-topbar">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box pe-0">
                <Link to="/" className="logo logo-dark">
                  <span className="logo-sm ms-n3">
                    <img src={logo} alt="" height="60" />
                  </span>
                  <span className="logo-lg">
                    <img src={logo} alt="" height="60" />
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </header>

        <div className="main-content">
          <div className="page-content">
            <Container fluid="md" className="p-0 p-md-2">
              <Outlet />
            </Container>
          </div>
        </div>

        <footer className="footer">
          <Container fluid="md">
            <Row>
              <Col xs={12}>{new Date().getFullYear()} © Clube do Tennis.</Col>
            </Row>
          </Container>
        </footer>
      </div>
    </div>
  )
}
